import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@components/Icon';
import SEO from '@components/seo/SEO';
import { BackTop, Drawer } from 'antd';

// 创建图标封装组件，与LandingPage中相同
const SafeIcon = ({ icon: IconName, useFa = true, ...props }) => {
  if (typeof IconName === 'string' && Icon[IconName]) {
    const IconComponent = Icon[IconName];
    return <IconComponent useFa={useFa} {...props} />;
  }
  
  if (typeof IconName === 'function' || typeof IconName === 'object') {
    return <IconName useFa={useFa} {...props} />;
  }
  
  return null;
};

const PrivacyPolicy = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <SEO 
        title="隐私政策 - 图美啦用户隐私保护说明 | 在线图片美化工具"
        description="了解图美啦如何保护您的隐私和个人信息。我们收集的数据类型、使用方式、安全措施以及您作为用户拥有的权利。"
        keywords="图美啦隐私政策,用户隐私保护,数据安全,图片处理隐私,在线工具隐私,个人信息保护"
        canonicalUrl="https://snapbeautify.toolooz.com/privacy"
      />
      {/* 导航栏 */}
      <header className="bg-white dark:bg-gray-900 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="flex items-center text-2xl font-bold text-purple-600 dark:text-purple-400">
                <img src="/favicon.svg" alt="图美啦" width="32" height="32" className="mr-2" />
                图美啦
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="Home" size={16} className="mr-1" />
                首页
              </Link>
              <Link to="/quick-start" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="BookOpen" size={16} className="mr-1" />
                快速上手
              </Link>
              <Link to="/about" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="User" size={16} className="mr-1" />
                关于我们
              </Link>
            </nav>
            <div className="flex md:hidden">
              <button 
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                onClick={() => setMobileMenuOpen(true)}
              >
                <SafeIcon icon="Menu" size={24} />
              </button>
            </div>
          </div>
        </div>
        
        {/* 移动设备导航菜单 */}
        <Drawer
          title="导航菜单"
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          width={250}
        >
          <div className="flex flex-col space-y-4">
            <Link 
              to="/" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Home" size={16} className="mr-1" />
              首页
            </Link>
            <Link 
              to="/quick-start" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="BookOpen" size={16} className="mr-1" />
              快速上手
            </Link>
            <Link 
              to="/about" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="User" size={16} className="mr-1" />
              关于我们
            </Link>
            <Link 
              to="/features" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Star" size={16} className="mr-1" />
              功能介绍
            </Link>
            <Link 
              to="/faq" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="HelpCircle" size={16} className="mr-1" />
              常见问题
            </Link>
            <div className="border-t border-gray-200 dark:border-gray-700 my-2 pt-2">
              <Link 
                to="/privacy" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Shield" size={16} className="mr-1" />
                隐私政策
              </Link>
              <Link 
                to="/terms" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="FileText" size={16} className="mr-1" />
                使用条款
              </Link>
              <Link 
                to="/copyright" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Award" size={16} className="mr-1" />
                版权声明
              </Link>
            </div>
          </div>
        </Drawer>
      </header>

      {/* 主要内容区域 */}
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 flex items-center">
              <SafeIcon icon="Shield" className="mr-3 text-purple-600 dark:text-purple-400" size={28} />
              隐私政策
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-4">更新日期: 2025年3月22日</span>
            </h1>

            <div className="prose dark:prose-invert max-w-none">
              <p className="text-gray-600 dark:text-gray-300">
                亲爱的用户，感谢您信任并使用图美啦！我们非常重视您的隐私和个人信息保护。本隐私政策旨在以简明易懂的方式，向您说明我们如何收集、使用和保护您的信息。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="FileText" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                信息收集
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                当您使用图美啦时，我们只会收集必要的信息来提供服务：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>
                  <strong>上传的图片</strong>：您上传到我们平台的图片仅在处理期间临时存储，完成处理后会立即从我们的服务器删除。我们不会永久保存您的图片。
                </li>
                <li>
                  <strong>浏览信息</strong>：为了改善用户体验，我们会收集浏览器类型、设备信息和访问时间等非个人身份信息。
                </li>
                <li>
                  <strong>Cookies</strong>：我们使用cookies来记住您的偏好设置（如深色模式），以便在您下次访问时提供更好的体验。
                </li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Lock" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                信息使用
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                我们收集的信息仅用于以下目的：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>提供、维护和改进我们的服务</li>
                <li>响应您的反馈、问题和请求</li>
                <li>分析和优化网站性能及用户体验</li>
                <li>防止潜在的欺诈和安全问题</li>
              </ul>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                我们承诺<strong>不会</strong>：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>出售您的个人信息</li>
                <li>将您的图片用于广告或营销目的</li>
                <li>与第三方共享您的信息，除非法律要求</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Server" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                数据安全
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                保护您的信息安全是我们的首要任务。我们采取了适当的技术和组织措施来保护您的数据：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>使用HTTPS加密传输所有数据</li>
                <li>图片处理完成后自动删除上传的原始文件</li>
                <li>定期安全审查和系统更新</li>
              </ul>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                不过，请记住，互联网传输不可能百分百安全。虽然我们努力保护您的个人信息，但我们不能保证信息传输的绝对安全。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Globe" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                第三方服务
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                图美啦使用一些第三方服务来帮助我们提供更好的用户体验：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>网站分析工具（如百度统计）</li>
                <li>CDN服务提供商</li>
                <li>云存储服务</li>
              </ul>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                这些第三方服务可能会收集一些基本信息，如IP地址和浏览器信息。我们建议您查看这些服务的隐私政策，了解他们如何处理您的数据。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="UserCheck" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                用户权利
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                作为用户，您拥有以下权利：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>访问和删除我们可能收集的关于您的信息</li>
                <li>选择不接受cookies（可能会影响某些功能）</li>
                <li>要求更正不准确的信息</li>
              </ul>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                如果您对我们如何处理您的信息有任何疑问或请求，请通过 <a href="mailto:support@toolooz.com" className="text-purple-600 dark:text-purple-400 hover:underline">support@toolooz.com</a> 联系我们。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="RefreshCw" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                隐私政策更新
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                我们可能会不时更新本隐私政策，以反映我们实践的变化或其他业务、法律原因。当我们更新政策时，会在网站上发布新版本，并更新顶部的"更新日期"。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                我们鼓励您定期查看此页面，了解我们的隐私实践有何变化。重大变更时，我们还会通过网站通知或其他适当方式告知您。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="MessageCircle" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                联系我们
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                如果您对本隐私政策有任何问题、意见或建议，请随时联系我们：
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-2 flex items-center">
                <SafeIcon icon="Mail" size={16} className="mr-2 text-purple-500 dark:text-purple-400" />
                <a href="mailto:support@toolooz.com" className="text-purple-600 dark:text-purple-400 hover:underline">support@toolooz.com</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* 页脚区域 */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <Link to="/" className="flex items-center text-xl font-bold text-white">
                <img src="/favicon.svg" alt="图美啦" width="24" height="24" className="mr-2" />
                图美啦
              </Link>
            </div>
            
            <div className="flex space-x-8">
              <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm">隐私政策</Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors text-sm">使用条款</Link>
              <Link to="/copyright" className="text-gray-300 hover:text-white transition-colors text-sm">版权声明</Link>
            </div>
            
            <div className="mt-4 md:mt-0 text-gray-400 text-sm">
              © {new Date().getFullYear()} 图美啦 | SnapBeautify
            </div>
          </div>
        </div>
      </footer>
      
      <BackTop>
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-purple-600 hover:bg-purple-700 text-white shadow-lg">
          <SafeIcon icon="ChevronUp" size={20} />
        </div>
      </BackTop>
    </div>
  );
};

export default PrivacyPolicy; 